import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeScoreSummary } from 'src/types/shared/Challenge';

export const fetchChallengeScoreSummaryRequest = createAction('fetchChallengeScoreSummaryRequest');
export const fetchChallengeScoreSummarySuccess = createAction<ChallengeScoreSummary>(
    'fetchChallengeScoreSummarySuccess',
);
export const fetchChallengeScoreSummaryFailure = createAction('fetchChallengeScoreSummaryFailure');

export const fetchChallengeScoreSummary = (id: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchChallengeScoreSummaryRequest());
    try {
        const { data } = await api.get<ChallengeScoreSummary>(
            `admin/challenges/${id}/application-summary`,
        );
        dispatch(fetchChallengeScoreSummarySuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchChallengeScoreSummaryFailure, e);
    }
};
